<template>
    <ModalTemplate :show="show" @close="close" width="max-w-2xl w-full" padding="p-0" :title="title"
        :teleportSource="modalTeleportTarget">
        <div class="bg-white rounded-lg p-4 max-h-[90dvh]">
            <div class="flex flex-col">
                <ReactiveHeightTransition>
                    <Transition name="fade" mode="out-in">
                        <div :key="showInviteForm
                            ? 'invite-form'
                            : 'affiliation-table'
                            ">
                            <AfilliationInvitationForm v-if="showInviteForm" @cancel="showInviteForm = false"
                                @sendInvites="onSendInvites" :modalTeleportTarget="'.' + modalTeleportTarget"
                                :confirmedItems="items" :sentRequests="sentRequests"
                                :recievedRequests="recievedRequests" :alreadyConfirmedMsg="alreadyConfirmedMsg"
                                :alreadySentMsg="alreadySentMsg" :alreadyRequestedMsg="alreadyRequestedMsg"
                                :sendInviteText="sendInviteText" />

                            <AffiliationTable v-else ref="affiliationTable" @reloadRelations="$emit('reloadRelations')"
                                @removeItem="
                                    (item_id) => $emit('removeItem', item_id)
                                " @showInviteForm="() => (showInviteForm = true)" :filterTabNames="filterTabNames"
                                :invitesEnabled="invitesEnabled" :items="items" :sentRequests="sentRequests"
                                :recievedRequests="recievedRequests" :canEdit="canEdit"
                                :approveAffiliationText="approveAffiliationText"
                                :definitiveItemName="definitiveItemName"
                                :definitiveRecievedName="definitiveRecievedName"
                                :definitiveSentName="definitiveSentName" :inviteText="inviteText"
                                :removeButtonText="removeButtonText" :initialTab="initialTab"
                                :onlyConfirmed="onlyConfirmed" :isManagingEmployees="isManagingEmployees"
                                :parentModel="parentModel" :isInQueue="isInQueue" class="mt-px" />
                        </div>
                    </Transition>
                </ReactiveHeightTransition>
            </div>
        </div>
    </ModalTemplate>
</template>

<script>
import ModalTemplate from '@/Components/Templates/ModalTemplate.vue'
import AffiliationTable from '@/Components/Panels/AffiliationPanel/AffiliationTable.vue'
import AfilliationInvitationForm from '@/Components/Panels/AffiliationPanel/AfilliationInvitationForm.vue'
import ReactiveHeightTransition from '@/Components/Transitions/ReactiveHeightTransition.vue'

export default {
    name: 'AffiliationModal',
    components: {
        ModalTemplate,
        AffiliationTable,
        AfilliationInvitationForm,
        ReactiveHeightTransition,
    },
    emits: ['reloadRelations', 'close', 'removeItem', 'sendInvites'],

    props: {
        parentModel: {
            type: Object,
            default: {}
        },
        show: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        sentRequests: {
            type: Array,
            default: [],
        },
        recievedRequests: {
            type: Array,
            default: [],
        },
        filterTabNames: {
            type: Object,
            required: true,
        },
        canEdit: {
            type: Boolean,
            required: true,
        },
        invitesEnabled: {
            type: Boolean,
            default: false,
        },
        approveAffiliationText: {
            type: String,
            required: true,
        },
        definitiveItemName: {
            type: String,
            required: true,
        },
        definitiveRecievedName: {
            type: String,
            required: true,
        },
        definitiveSentName: {
            type: String,
            required: false,
        },
        alreadyConfirmedMsg: {
            type: String,
            required: false,
        },
        alreadySentMsg: {
            type: String,
            required: false,
        },
        alreadyRequestedMsg: {
            type: String,
            required: false,
        },
        inviteText: {
            type: String,
            required: false,
        },
        initialTab: {
            type: [String, null],
            default: null,
        },
        sendInviteText: {
            type: String,
            default: null,
        },
        removeButtonText: {
            type: String,
            default: null,
        },
        onlyConfirmed: {
            type: Boolean,
            default: false,
        },
        isManagingEmployees: {
            type: Boolean,
            default: false
        },
        isInQueue: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            showInviteForm: false,
            modalTeleportTarget: 'affiliation-modal',
        }
    },

    methods: {
        onSendInvites(usersToInvite) {
            this.$emit('sendInvites', usersToInvite)
            this.showInviteForm = false
            setTimeout(() => {
                this.$refs.affiliationTable.goToInvitationsTab()
            }, 500)
        },

        close() {
            this.showInviteForm = false
            this.$emit('close')
        },
    },
}
</script>
